import React, { useState } from 'react';
import api from '../api/axios';
import toast from 'react-hot-toast';

export default function ImportData() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return toast.error('Please select a CSV file');
    setLoading(true);
    setResult(null);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await api.post('/businesses/import/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setResult(res.data);
      toast.success(`Imported ${res.data.created} businesses`);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Import failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header"><h1>Import Business Data</h1></div>

      <div className="card">
        <h3 style={{marginBottom:'12px'}}>CSV Format</h3>
        <p style={{fontSize:'13px',color:'#666',marginBottom:'16px'}}>
          Upload a <strong>CSV</strong> or <strong>Excel (.xlsx)</strong> file with these headers: SUB COUNTY, WARD, SUB WARD, MARKET, BUSINESS NAME,
          PLOT NO, TRADER'S NAME, CONTACT, NATURE OF BUSINESS, SBP NO, MR NO, MODE OF PAYMENT,
          TRANSACTION NO, AMOUNT, ISSUING OFFICER
        </p>

        <form onSubmit={handleSubmit}>
          <div className="upload-zone" onClick={() => document.getElementById('csv-input').click()}>
            <input id="csv-input" type="file" accept=".csv,.xlsx,.xls" style={{display:'none'}}
              onChange={e => setFile(e.target.files[0])} />
            <p style={{fontSize:'16px',marginBottom:'8px'}}>
              {file ? `📄 ${file.name}` : '📁 Click to select CSV file'}
            </p>
            <p style={{fontSize:'12px',color:'#999'}}>.csv and .xlsx files accepted</p>
          </div>

          <button type="submit" className="btn btn-primary" style={{marginTop:'16px'}} disabled={loading || !file}>
            {loading ? 'Importing...' : 'Import Data'}
          </button>
        </form>
      </div>

      {result && (
        <div className="card" style={{marginTop:'16px'}}>
          <h3 style={{color:'#1a5632',marginBottom:'12px'}}>Import Results</h3>
          <p>✅ Successfully imported: <strong>{result.created}</strong> businesses</p>
          {result.total_errors > 0 && (
            <>
              <p style={{color:'#dc3545',marginTop:'8px'}}>❌ Errors: {result.total_errors}</p>
              <ul style={{fontSize:'12px',color:'#666',marginTop:'8px',paddingLeft:'20px'}}>
                {result.errors.map((e, i) => <li key={i}>{e}</li>)}
              </ul>
            </>
          )}
        </div>
      )}
    </div>
  );
}
